// extracted by mini-css-extract-plugin
var _1 = "Jm_cQ";
var _2 = "s8Udu";
var _3 = "j3qjJ";
var _4 = "sKVLF";
var _5 = "cveP9";
var _6 = "kala9";
var _7 = "wFeuC";
var _8 = "PcRQA";
export { _1 as "base", _2 as "colorize", _3 as "common", _4 as "leadingWhitespace", _5 as "specific", _6 as "surroundingWhitespace", _7 as "trailingWhitespace", _8 as "valid" }
